import { render } from "./AccessDenied.vue?vue&type=template&id=62634ab2&scoped=true"
import script from "./AccessDenied.vue?vue&type=script&lang=js"
export * from "./AccessDenied.vue?vue&type=script&lang=js"

import "./AccessDenied.vue?vue&type=style&index=0&id=62634ab2&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/storage-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62634ab2"]])

export default __exports__